export default __webpack_public_path__ + "static/media/Background_00106.f784d2e0.png";